export default __webpack_public_path__ + "static/media/leave-sm.a0791d09.png";